export default __webpack_public_path__ + "static/media/dumbbell.f20e2ad3.svg";